// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://mylidgxdzvapsairwces.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im15bGlkZ3hkenZhcHNhaXJ3Y2VzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzk1NDU1MjYsImV4cCI6MjA1NTEyMTUyNn0.-jbZdILfY9LT19zN510hd4UzHda8G92umXwx_FXJbr4";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);